import { LinearProgress } from "@mui/material";
import React, { Suspense } from "react";

const FallbackWrappedElement = ({ children }) => {
  return (
    <React.Fragment>
      <Suspense fallback={<LinearProgress />}>{children}</Suspense>
    </React.Fragment>
  );
};

export default FallbackWrappedElement;
